import {useEffect} from "react";

import {
  AFFILIATE_CODE_PARAM,
  readAffiliateCodeFromSearch,
  storeAffiliateCode,
} from "@/utils/affiliate-code";
import {stripSearchParam} from "@/utils/url";

/**
 * Captures the `?ac=` affiliate code from the landing URL and stores it in a
 * cookie, so the referral survives an error on the way to registration.
 *
 * A malformed value is stripped regardless, so it cannot be re-shared out of
 * the address bar. A valid one is only stripped once the cookie really holds
 * it: with cookies blocked the param has to stay in the URL, because it is
 * then the only place registration can still read the referral from.
 */
const useCaptureAffiliateCode = () => {
  useEffect(() => {
    const code = readAffiliateCodeFromSearch(window.location.search);
    if (code && !storeAffiliateCode(code)) return;

    stripSearchParam(AFFILIATE_CODE_PARAM);
  }, []);
};

export default useCaptureAffiliateCode;
